export const NIGERIAN_STATES = {
    "Abia":	"440001",
    "Adamawa":	"640001",
    "Akwa Ibom":	"520001",
    "Anambra":	"420001",
    "Bauchi":	"740001",
    "Bayelsa":	"561001",
    "Benue":	"970001",
    "Borno":	"600001",
    "Cross River":	"540001",
    "Delta":	"320001",
    "Ebonyi":	"840001",
    "Edo":	"300001",
    "Ekiti":	"360001",
    "Enugu":	"400001",
    "Gombe":	"760001",
    "Imo":	"460001",
    "Jigawa":	"720001",
    "Kaduna":	"700001",
    "Kano":	"800001",
    "Katsina":	"820001",
    "Kebbi":	"860001",
    "Kogi":	"260001",
    "Kwara":	"240001",
    "Lagos":	"100001",
    "Nasarawa":	"962001",
    "Niger":	"920001",
    "Ogun":	"110001",
    "Ondo":	"340001",
    "Osun":	"230001",
    "Oyo":	"200001",
    "Plateau":	"930001",
    "Rivers":	"500001",
    "Sokoto":	"840001",
    "Taraba":	"660001",
    "Yobe":	"320001",
    "Zamfara":	"860001",
    "FCT":	"900001",
}